import {get, put} from "../util/http.service";

export const getQuotes = () => get("/quotes");

export const getQuote = symbol => get("/quotes/" + symbol);

export const toggleQuoteFavorite = symbol => put("/quotes/" + symbol + "/favorite");
